import React from 'react';
import styled from '@emotion/styled';
import { Only } from 'ui/components/elements/Only/Only';
import { mqMin } from 'utils/responsive';
import LeadBgSpImg from 'ui/images/top_for_agent/topLead_bg_sp.svg';
import LeadBgPcImg from 'ui/images/top_for_agent/topLead_bg_pc.svg';
import LeadLogoImg from 'ui/images/top_for_agent/topLead_logo.svg';
import LeadWebp from 'ui/images/top_for_agent/topLead_img@2x.webp';
import LeadSp2X from 'ui/images/top_for_agent/topLead_img@2x.png';

const Section = styled.section`
    position: relative;
    background-image: url(${LeadBgSpImg});
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center center;
    padding: 0 0 56px 0;

    &::before {
        position: absolute;
        content: '';
        display: block;
        width: 0;
        height: 0;
        left: 50%;
        transform: translateX(-50%);
        border-style: solid;
        border-color: #e7e7e7 transparent transparent transparent;
        border-width: 19px 23px 0px 23px;
    }

    ${mqMin('NARROW')} {
        background-image: url(${LeadBgPcImg});
        padding: 0 0 77px 0;

        &::before {
            border-width: 22px 27px 0px 27px;
        }
    }
`;

const H2 = styled.h2`
    position: relative;
    text-align: center;
    line-height: 1.5em;
    letter-spacing: 0.05em;
    font-size: 1.5rem; /*24px*/
    margin-bottom: 23px;
    padding: 61px 0 0 0;

    img {
        display: inline-block;
        width: 104px;
        vertical-align: middle;
    }

    ${mqMin('NARROW')} {
        font-size: 2rem; /*32px*/
        line-height: 1.8em;
        margin-bottom: 40px;
        padding: 106px 0 0 0;

        img {
            width: 208px;
            vertical-align: bottom;
        }
    }
`;

const OrangeStrong = styled.strong`
    color: var(--color-orange);
`;

const TopLeadLarge = styled.span`
    position: relative;
    font-size: 1.75rem;
    color: var(--color-orange);

    ${mqMin('NARROW')} {
        font-size: 2.375rem;
    }
`;

const Attention = styled.span`
    letter-spacing: 0;
    font-size: 0.875rem; /*14px*/
    color: #899da7;

    ${mqMin('NARROW')} {
        font-size: 1rem;
    }
`;

const LeadImg = styled.img`
    width: 350px;
    margin: 0 auto 0 auto;

    ${mqMin('NARROW')} {
        width: 770px;
    }
`;

export const Lead: React.FC = () => {
    return (
        <Section>
            <H2 className="fadein fadein_y">
                <img src={LeadLogoImg} />
                なら、
                <Only sp>
                    <br />
                </Only>
                <TopLeadLarge>コスト</TopLeadLarge>
                <OrangeStrong>を</OrangeStrong>
                <TopLeadLarge>かけず</TopLeadLarge>
                <OrangeStrong>に</OrangeStrong>
                <Attention>※</Attention>
                <br />
                <TopLeadLarge>M&A検討企業</TopLeadLarge>と出会える。
                <Only sp>
                    <br />
                </Only>
                <Attention>※マッチング成立まで基本無料</Attention>
            </H2>
            <picture>
                <source type="image/webp" srcSet={LeadWebp} />
                <LeadImg src={LeadSp2X} alt="複数の会社と面談イメージ" className="fadein fadein_y" />
            </picture>
        </Section>
    );
};
